<template>
  <li
    v-if="member"
    class="side-members__item member"
    @click="onClickMember">
    <div
      class="px-3 pt-3 pb-2"
      :class="tabClass">
      <div class="d-flex align-items-center">
        <img
          v-if="member.avatar"
          :src="member.avatar"
          class="img-fluid rounded-circle side-member__img mr-3 align-self-center">
        <span
          v-else
          class="material-icons member__icon mr-3 p-1 align-self-center">
          person
        </span>
        <div
          class="side-member__content"
          :class="{searched: isSearched}">
          <p class="side-member__name">
            <span
              v-if="member.tag1 || member.tag2"
              class="side-member__tag">{{ member | userTag }}</span>
            {{ member.name }}
          </p>
          <p
            v-if="isAnyManager && member.finalDestination"
            class="side-member__title">
            {{ member.finalDestination.destinationName }}
          </p>
          <p
            v-else
            class="side-member__title">
            {{ member.position }}
          </p>
        </div>
        <div class="side-members__suffix">
          <slot name="suffix" />
        </div>
      </div>
      <daily-work-stack-list
        class="mt-1"
        :selected-date="selectedDate"
        :daily-work-list="dailyWorkList" />
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import DailyWorkStackList from '@/components/view/DailyWorkStackList.vue'

export default {
  components: {
    DailyWorkStackList
  },
  props: {
    member: { 
      type: Object,
      default: null
    },
    selectedDate: {
      type: Date,
      required: true
    },
    dailyWorkList: {
      type: Array,
      default: () => []
    },
    isSearched: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isAnyManager']),
    tabClass() {
      if (this.isActive) {
        return 'side-member__link--current'
      }
      return 'side-member__link'
    },
    isActive() {
      return this.member.id === this.$route.params.id
    }
  },
  methods: {
    onClickMember() {
      this.$emit('click', this.member)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/members';
@import '@/assets/stylesheets/member';

.side-member__tag {
  display: inline-block;
  font-size: 11px;
  line-height: 1.2;
  padding: 1px 5px;
  border-radius: 3px;
  background: #e0e0e0;
  color: #555;
  margin-right: 2px;
}

.side-member__title {
  margin-left: auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 180px;
}

.side-members {
  &__item {
    position: relative;
    cursor: pointer;
  }

  &__suffix {
    margin-left: auto;
  }
}

.side-member__content {
  flex-grow: 1;
  padding: 5px 10px;
  margin-left: -10px;
  margin-right: 4px;
  border-radius: 5px;

  &.searched {
    background: $highlight;
  }
}
</style>